import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class LoaderService {
    loaderStatus = new BehaviorSubject<any>(false);
    setLoaderStatus$ = this.loaderStatus.asObservable();

    public showLoader(): void {
        // if (!Swal.isVisible()) {
        //     Swal.fire({
        //         allowOutsideClick: false,
        //         showConfirmButton: false,
        //         background: 'rgb(192, 192, 192, 0)',
        //         didOpen: () => {
        //             if (!Swal.isLoading()) {
        //                 Swal.showLoading();
        //             }
        //         },
        //     });
        // }
    }

    public hideLoader(): void {
        // if (Swal.isVisible()) {
        //     if (Swal.isLoading()) {
        //         Swal.hideLoading();
        //     }
        //     Swal.close();
        // }
    }


}
